<div class="row justify-content-between">  
  <button mat-icon-button *ngIf="notification.cancel" (click)="snackBarRef.dismiss();">
      <mat-icon>close</mat-icon>
  </button>
  <small class="mt-1">{{ notification.message }}</small>  
  <button mat-icon-button *ngIf="notification.action" (click)="snackBarRef.dismissWithAction()">
      <mat-icon>done</mat-icon>
  </button>
</div>